export const getReturnManifestListTab = (initialFilter = {}) => ({
  field: 'preset',
  isPreset: true,
  defaultTab: 'open',
  tabs: [
    {
      key: 'open',
      label: 'Open',
      preset: {
        ...initialFilter,
        return_manifest_status: ['created'],
      },
    },
    {
      key: 'pending',
      label: 'Pending',
      preset: {
        ...initialFilter,
        return_manifest_status: ['pending'],
      },
    },
    {
      key: 'all',
      label: 'All',
      preset: {
        ...initialFilter,
      },
    },
  ],
});
